import { memo } from 'react';
import { Grid } from '@mui/material';
import EditData from './edit-data';
import RegistrationCitizenship from './citizenship';
import CitizenshipList from './citizenship-list';
import AccordionPerson from 'shell/components/shared/person';

interface FormRegistrationCitizenshipProps {
  isNationalSearch?: string;
  disabled?: boolean;
  isNotDisabledCitizenship?: boolean;
}

const FormRegistrationCitizenshipComponent = ({
  isNationalSearch,
  disabled,
  isNotDisabledCitizenship,
}: FormRegistrationCitizenshipProps): React.ReactElement => {
  return (
    <Grid item container spacing={2}>
      <Grid item xs={12}>
        <AccordionPerson disabled />
        <EditData disabled={disabled} />
        <CitizenshipList />
        <RegistrationCitizenship
          isNationalSearch={isNationalSearch}
          disabled={isNotDisabledCitizenship ? false : disabled}
        />
      </Grid>
    </Grid>
  );
};

FormRegistrationCitizenshipComponent.displayName = 'Form Registration Citizenship component';

const FormRegistrationCitizenship = memo(FormRegistrationCitizenshipComponent);

export default FormRegistrationCitizenship;
